"use strict";

import { createPopper } from "@popperjs/core";
import * as bootstrap from "bootstrap";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css/bundle";
import AOS from "aos";
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import JustValidate from "just-validate";
import Datepicker from "vanillajs-datepicker/Datepicker";
import es from "vanillajs-datepicker/locales/es";

Object.assign(Datepicker.locales, es);

export function ppModalPopup() {
  const elemento = document.getElementById("js-modal-popup");

  if (elemento) {
    // Si no existe la cookie la seteamos
    if (get_cookie("pp_popup") === "") {
      const modal = new bootstrap.Modal(elemento);
      modal.show();
    }

    elemento.addEventListener("hidden.bs.modal", function (event) {
      set_cookie("pp_popup", "true", 30);
    });
  }
}

function get_cookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function set_cookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function ppMasonry() {
  const elem = document.querySelector(".grid");

  var msnry = new Masonry(elem, {
    // options
    itemSelector: ".item-masonry-test",
    gutter: ".gutter-sizer",
    resize: true,
    horizontalOrder: true,
  });

  imagesLoaded(elem).on("progress", function () {
    // layout Masonry after each image loads
    msnry.layout();
  });

  Fancybox.bind('[data-fancybox="gallery"]', {
    // Your custom options
  });
}

Fancybox.bind('[data-fancybox="gallery"]', {
  // Your custom options
});

export function ppMasonrycarganews() {
  var containers = document.querySelectorAll(".masonry-layout");
  containers.forEach(function (container) {
    new Masonry(container, {
      itemSelector: ".item-masonry-test",
      fitWidth: true,
    });
  });
}

export function cargar_corporativos() {
  const init = function () {
    const elementos = document.querySelectorAll(".js-cargar-corporativos");

    elementos.forEach(function (elemento) {
      if (elemento.dataset.corporativosBound === "true") return;
      elemento.dataset.corporativosBound = "true";

      elemento.addEventListener("click", async function (e) {
        e.preventDefault();

        if (elemento.dataset.pending === "true") return;
        const module = elemento.closest(".tab-pane, .woo-destacados, section");
        const loading = module?.querySelector(".js-formulario-loadingblog");
        const noticiasContainerId = elemento.dataset.contenedor;
        const noticiasContainer = document.getElementById(noticiasContainerId);
        if (!noticiasContainer) return;

        const cantidadACargar = Math.max(
          1,
          parseInt(elemento.dataset.cantidadnew || "12", 10) || 12
        );
        const totalProductos = parseInt(
          elemento.dataset.total ||
            noticiasContainer.dataset.totalCorporativos ||
            "0",
          10
        );
        const currentOffset = parseInt(elemento.dataset.offset || "0", 10) || 0;

        if (currentOffset >= totalProductos) {
          elemento.classList.add("d-none");
          return;
        }

        elemento.dataset.pending = "true";
        elemento.disabled = true;
        if (loading) loading.classList.remove("d-none");
        elemento.classList.add("d-none");

        try {
          const bodyParams = new URLSearchParams();
          bodyParams.append("action", "cargar_mas_corporativos");
          bodyParams.append("nonce", ajax_script.corporativos_nonce);
          bodyParams.append("offset", currentOffset);
          bodyParams.append("cantidad_cargar", cantidadACargar);

          const response = await fetch(ajax_script.ajax_url, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            },
            body: bodyParams.toString()
          });
          const payload = await response.json();

          if (!response.ok || !payload.success || !payload.data) {
            throw new Error(payload?.data?.message || "No fue posible cargar los productos.");
          }

          if (payload.data.html) {
            noticiasContainer.insertAdjacentHTML("beforeend", payload.data.html);
          }

          elemento.dataset.offset = String(payload.data.next_offset || currentOffset);
          elemento.dataset.total = String(payload.data.total || totalProductos);
          if (payload.data.has_more) {
            elemento.classList.remove("d-none");
          }
        } catch (error) {
          console.error("Error al cargar productos corporativos:", error);
          elemento.classList.remove("d-none");
        } finally {
          delete elemento.dataset.pending;
          elemento.disabled = false;
          if (loading) loading.classList.add("d-none");
        }
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
}



export function cargar_noticias() {
  const init = function () {
    const elementos = document.querySelectorAll(".js-cargar-mas");

    elementos.forEach(function (elemento) {
      if (elemento.dataset.newsBound === "1") return;
      elemento.dataset.newsBound = "1";

      elemento.addEventListener("click", function (e) {
        e.preventDefault();
        if (elemento.dataset.loading === "1") return;

        const loading =
          elemento
            .closest(".general-blog, .tab-pane, section")
            ?.querySelector(".js-formulario-loadingblog") ||
          document.querySelector(".js-formulario-loadingblog");
        const id = elemento.dataset.categoria || "allnews";
        const btname = elemento.dataset.btname || "";
        const blogUrl = elemento.dataset.blogUrl || window.location.href;
        const cantidadACargar = Math.max(
          1,
          Math.min(Number.parseInt(elemento.dataset.cantidadnew, 10) || 8, 24)
        );
        const noticiasContainer = document.getElementById(
          elemento.dataset.contenedor || ""
        );

        if (
          !noticiasContainer ||
          typeof ajax_script === "undefined" ||
          !ajax_script.ajax_url ||
          !ajax_script.noticias_nonce
        ) {
          return;
        }

        const totalNoticias =
          Number.parseInt(
            noticiasContainer.getAttribute("data-total-noticias"),
            10
          ) || 0;

        const noticiasCargadas =
          noticiasContainer.querySelectorAll(".item-masonry-test").length;

        if (!totalNoticias || noticiasCargadas >= totalNoticias) {
          elemento.classList.add("d-none");
          return;
        }

        const finish = function () {
          elemento.dataset.loading = "0";
          if (loading) loading.classList.add("d-none");
        };
        const xhr = new XMLHttpRequest();

        elemento.dataset.loading = "1";
        if (loading) loading.classList.remove("d-none");
        elemento.classList.add("d-none");

        xhr.open("POST", ajax_script.ajax_url, true);
        xhr.setRequestHeader(
          "Content-Type",
          "application/x-www-form-urlencoded; charset=UTF-8"
        );
        xhr.onload = function () {
          const html = xhr.responseText.trim();

          if (xhr.status === 200 && html) {
            noticiasContainer.insertAdjacentHTML("beforeend", html);
            const totalCargadas =
              noticiasContainer.querySelectorAll(".item-masonry-test").length;
            if (totalCargadas < totalNoticias) {
              elemento.classList.remove("d-none");
            }
          } else if (xhr.status !== 200) {
            elemento.classList.remove("d-none");
          }
          finish();
        };
        xhr.onerror = function () {
          elemento.classList.remove("d-none");
          finish();
        };
        xhr.onabort = xhr.onerror;
        xhr.ontimeout = xhr.onerror;
        xhr.timeout = 15000;

        const data = new URLSearchParams();
        data.append("action", "cargar_mas_noticias");
        data.append("nonce", ajax_script.noticias_nonce);
        data.append("offset", noticiasCargadas);
        data.append("cantidad_cargar", cantidadACargar);
        data.append("categoria", id);
        data.append("btname", btname);
        data.append("blog_url", blogUrl);
        xhr.send(data);
      });
    });

    const tabs = document.querySelectorAll('[data-bs-toggle="tab"]');
    tabs.forEach(function (tab) {
      if (tab.dataset.newsTabBound === "1") return;
      tab.dataset.newsTabBound = "1";

      tab.addEventListener("shown.bs.tab", function () {
        const target = tab.getAttribute("data-bs-target") || "";
        if (!target.startsWith("#")) return;
        const targetId = target.substring(1);
        const targetTab = document.getElementById(targetId);
        if (targetTab) initializeMasonry(targetTab);
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  function initializeMasonry(container) {
    const grid = container.querySelector(".grid");
    if (grid) {
      const msnry = new Masonry(grid, {
        itemSelector: ".item-masonry-test",
        gutter: ".gutter-sizer",
        horizontalOrder: true,
      });

      imagesLoaded(grid).on("progress", function () {
        msnry.layout();
      });
    }
  }
}

export function redesCompartir() {
  let elementos = document.querySelectorAll(".js-compartir");

  elementos.forEach(function (elemento) {
    elemento.addEventListener("click", (event) => {
      event.preventDefault();
      let url = elemento.href;

      window.open(
        url,
        "fbShareWindow",
        "height=550, width=650, top=" +
          (window.innerHeight / 2 - 275) +
          ", left=" +
          (window.innerWidth / 2 - 225) +
          ", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
      );
    });
  });
}

export function ppueblosModalFormulario() {
  const elementos = document.querySelectorAll(".js-modal-formulario");

  elementos.forEach(function (elemento) {
    const url = elemento.dataset.url;
    const modal = new bootstrap.Modal(elemento);

    modal.show();
    window.history.pushState({}, document.title, url);
  });
}

export function ppueblosModalFormulario2() {
  const elementos = document.querySelectorAll(".js-modal-formulario2");

  elementos.forEach(function (elemento) {
    const url = elemento.dataset.url;
    const modal = new bootstrap.Modal(elemento);

    modal.show();
    window.history.pushState({}, document.title, url);
  });
}
let ppMensajeBound = false;

export function ppMensaje() {
  if (ppMensajeBound) return;
  ppMensajeBound = true;

  if (document.readyState === "complete") {
    ppMensajeAltura();
  } else {
    window.addEventListener("load", ppMensajeAltura, { once: true });
  }
  window.addEventListener("resize", ppMensajeAltura);
}

export function ppueblosFormulario2() {
  const formularios = document.querySelectorAll(".js-formulario2");

  formularios.forEach((formulario) => {
    const validation = new JustValidate(formulario);

    validation
      .addField('[name="nombre"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="nombreemprendimiento"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="razonsocial"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="rutempresa"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="giro"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="direccion"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="comuna"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="region"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="web"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="correo"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
        {
          rule: "email",
          errorMessage: "Formato inválido",
        },
      ])
      .addField('[name="rutcontacto"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="telefono"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="vecino"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="adjuntar"]', [
        {
          rule: "minFilesCount",
          value: 1,
          errorMessage: "Debe seleccionar 1 archivo",
        },
        {
          rule: "files",
          value: {
            files: {
              extensions: ["pdf", "doc", "txt", "jpg", "jpeg"],
            },
          },
          errorMessage: "El archivo debe tener un formato pdf, doc, txt, jpg o jpeg",
        },
      ])
      .onSuccess((event) => {
        event.preventDefault();

        const params = new FormData(event.currentTarget);
        const contenedor = formulario.closest(".js-formulario-caja2");
        const loading = contenedor.querySelector(".js-formulario-loading2");

        loading.classList.add("formulario-loading--activo");

        fetch(ajax_script.ajax_url, {
          method: "POST",
          body: params,
          contentType: false,
          processData: false,
        })
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            loading.classList.remove("formulario-loading--activo");

            if (res.error) {
              alert(res.mensajes);
            } else {
              window.location = res.redireccion;
            }
          })
          .catch(() => {
            loading.classList.remove("formulario-loading--activo");
            alert("No fue posible enviar el formulario. Inténtalo nuevamente.");
          });
      });
  });
}

export function ppueblosFormulario() {
  const formularios = document.querySelectorAll(".js-formulario");
  formularios.forEach((formulario) => {
    const validation = new JustValidate(formulario);
    const error_nombre = formulario.querySelector('input[name="nombre"]')
      .dataset.error1;
    const error_nombre2 = formulario.querySelector('input[name="nombre"]')
      .dataset.error2;

    const error_email1 = formulario.querySelector('input[name="correo"]')
      .dataset.error1;
    const error_email2 = formulario.querySelector('input[name="correo"]')
      .dataset.error2;

    const error_empresa = formulario.querySelector('input[name="empresa"]')
      .dataset.error1;
    const error_empresa2 = formulario.querySelector('input[name="empresa"]')
      .dataset.error2;
    const error_empresa3 = formulario.querySelector('input[name="empresa"]')
      .dataset.error3;

    const error_cantidad = formulario.querySelector('input[name="cantity"]')
      .dataset.error1;
    const error_cantidad2 = formulario.querySelector('input[name="cantity"]')
      .dataset.error2;
    const error_cantidad3 = formulario.querySelector('input[name="cantity"]')
      .dataset.error3;

    const error_presupuesto = formulario.querySelector(
      'input[name="presupuesto"]'
    ).dataset.error1;
    const error_presupuesto2 = formulario.querySelector(
      'input[name="presupuesto"]'
    ).dataset.error2;
    const error_presupuesto3 = formulario.querySelector(
      'input[name="presupuesto"]'
    ).dataset.error3;

    const error_fechaentrega = formulario.querySelector(
      'input[name="fechaentrega"]'
    ).dataset.error1;

    const error_telefono1 = formulario.querySelector('input[name="telefono"]')
      .dataset.error1;
    const error_telefono2 = formulario.querySelector('input[name="telefono"]')
      .dataset.error2;
    const error_telefono3 = formulario.querySelector('input[name="telefono"]')
      .dataset.error3;

    const error_mensaje = formulario.querySelector('textarea[name="mensaje"]')
      .dataset.error1;
    const error_mensaje2 = formulario.querySelector('textarea[name="mensaje"]')
      .dataset.error2;

    const selectElement = formulario.querySelector('select[name="select"]')
      .dataset.error1;

    const fechaEntregaInput = formulario.querySelector(
      'input[name="fechaentrega"]'
    );
    const label = formulario.querySelector(
      'label[for="fechaentrega"], #fechaentrega_label'
    );
    /*
		document.addEventListener("DOMContentLoaded", function () {
			
			const fechaInput = document.querySelector('#fechaentrega');
			flatpickr(fechaInput, {
			  dateFormat: "d/m/Y", 
			  minDate: "today",
			  disableMobile: "true"

			});
		  });
		  */
    const today = new Date();

    if (fechaEntregaInput && typeof Datepicker !== "undefined") {
      new Datepicker(fechaEntregaInput, {
        format: "dd/mm/yyyy",
        locale: "es",
        language: "es",
        minDate: today,
      });
    }

    if (label && fechaEntregaInput) {
      fechaEntregaInput.addEventListener("change", () => {
        if (fechaEntregaInput.value) {
          label.style.display = "none";
        } else {
          label.style.display = "block";
        }
      });
    }

    const quantityInput = formulario.querySelector('input[name="cantity"]');

    quantityInput.addEventListener("input", () => {
      let inputValue = quantityInput.value.replace(/\D/g, "");
      if (inputValue !== "") {
        inputValue = parseInt(inputValue, 10);
        quantityInput.value = inputValue.toLocaleString("es-ES");
      } else {
        quantityInput.value = "";
      }
    });

    const presupuestoInput = formulario.querySelector(
      'input[name="presupuesto"]'
    );

    presupuestoInput.addEventListener("input", () => {
      let inputValue = presupuestoInput.value.replace(/\D/g, "");
      if (inputValue !== "") {
        inputValue = parseInt(inputValue, 10);
        presupuestoInput.value = inputValue.toLocaleString("es-ES");
      } else {
        presupuestoInput.value = "";
      }
    });

    const datePicker2 = formulario.querySelector('input[name="fechaentrega"]');

    datePicker2.addEventListener("input", () => {
      const selectedDate = new Date(datePicker2.value);
      const currentDate = new Date();

      if (selectedDate < currentDate) {
        datePicker2.value = "";
      }
    });

    validation
      .addField('[name="nombre"]', [
        {
          rule: "required",
          errorMessage: error_nombre,
        },
        {
          rule: "customRegexp",
          value: /^[A-Za-z\sáéíóúÁÉÍÓÚñÑ]+$/,
          errorMessage: error_nombre2,
        },
      ])
      .addField('[name="correo"]', [
        {
          rule: "required",
          errorMessage: error_email1,
        },
        {
          rule: "email",
          errorMessage: error_email2,
        },
      ])
      .addField('[name="telefono"]', [
        {
          rule: "required",
          errorMessage: error_telefono1,
        },
        {
          rule: "number",
          errorMessage: error_telefono2,
        },
        {
          rule: "minLength",
          value: 9,
          errorMessage: error_telefono3,
        },
        {
          rule: "maxLength",
          value: 9,
          errorMessage: error_telefono3,
        },
      ])
      .addField('[name="empresa"]', [
        {
          rule: "required",
          errorMessage: error_empresa,
        },
        {
          rule: "minLength",
          value: 3,
          errorMessage: error_empresa2,
        },
        {
          rule: "maxLength",
          value: 20,
          errorMessage: error_empresa3,
        },
      ])
      .addField('[name="cantity"]', [
        {
          rule: "required",
          errorMessage: error_cantidad,
        },
        {
          rule: "customRegexp",
          value: /^[0-9.]+$/,
          errorMessage: error_cantidad2,
        },
        {
          rule: "maxLength",
          value: 50,
          errorMessage: error_cantidad3,
        },
      ])
      .addField('[name="presupuesto"]', [
        {
          rule: "required",
          errorMessage: error_presupuesto,
        },
        {
          rule: "customRegexp",
          value: /^[0-9.]+$/,
          errorMessage: error_presupuesto2,
        },
        {
          rule: "maxLength",
          value: 50,
          errorMessage: error_presupuesto3,
        },
      ])
      .addField('[name="fechaentrega"]', [
        {
          rule: "required",
          errorMessage: error_fechaentrega,
        },
      ])

      .addField('[name="select"]', [
        {
          rule: "required",
          errorMessage: selectElement,
        },
      ])
      .addField('[name="mensaje"]', [
        {
          rule: "required",
          errorMessage: error_mensaje,
        },
        {
          rule: "maxLength",
          value: 500,
          errorMessage: error_mensaje2,
        },
      ])
      .onSuccess((event) => {
        event.preventDefault();

        const params = new URLSearchParams(new FormData(event.currentTarget));
        const contenedor = formulario.closest(".js-formulario-caja");
        const loading = contenedor.querySelector(".js-formulario-loading");

        loading.classList.add("formulario-loading--activo");

        fetch(ajax_script.ajax_url, {
          method: "POST",
          body: params,
        })
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            loading.classList.remove("formulario-loading--activo");

            if (res.error) {
              alert(res.mensajes);
            } else {
              window.location = res.redireccion;
            }
          })
          .catch(() => {
            loading.classList.remove("formulario-loading--activo");
            alert("No fue posible enviar el formulario. Inténtalo nuevamente.");
          });
      });
  });
}

export function ppueblosFormulariocontacto2() {
  
  document.addEventListener("DOMContentLoaded", function () {
    var regionesData = {
      regiones: [
        {
          region: "Arica y Parinacota",
          comunas: ["Arica", "Camarones", "Putre", "General Lagos"],
        },
        {
          region: "Tarapacá",
          comunas: [
            "Iquique",
            "Alto Hospicio",
            "Pozo Almonte",
            "Camiña",
            "Colchane",
            "Huara",
            "Pica",
          ],
        },
        {
          region: "Antofagasta",
          comunas: [
            "Antofagasta",
            "Mejillones",
            "Sierra Gorda",
            "Taltal",
            "Calama",
            "Ollagüe",
            "San Pedro de Atacama",
            "Tocopilla",
            "María Elena",
          ],
        },
        {
          region: "Atacama",
          comunas: [
            "Copiapó",
            "Caldera",
            "Tierra Amarilla",
            "Chañaral",
            "Diego de Almagro",
            "Vallenar",
            "Alto del Carmen",
            "Freirina",
            "Huasco",
          ],
        },
        {
          region: "Coquimbo",
          comunas: [
            "La Serena",
            "Coquimbo",
            "Andacollo",
            "La Higuera",
            "Paiguano",
            "Vicuña",
            "Illapel",
            "Canela",
            "Los Vilos",
            "Salamanca",
            "Ovalle",
            "Combarbalá",
            "Monte Patria",
            "Punitaqui",
            "Río Hurtado",
          ],
        },
        {
          region: "Valparaíso",
          comunas: [
            "Valparaíso",
            "Casablanca",
            "Concón",
            "Juan Fernández",
            "Puchuncaví",
            "Quintero",
            "Viña del Mar",
            "Isla de Pascua",
            "Los Andes",
            "Calle Larga",
            "Rinconada",
            "San Esteban",
            "La Ligua",
            "Cabildo",
            "Papudo",
            "Petorca",
            "Zapallar",
            "Quillota",
            "Calera",
            "Hijuelas",
            "La Cruz",
            "Nogales",
            "San Antonio",
            "Algarrobo",
            "Cartagena",
            "El Quisco",
            "El Tabo",
            "Santo Domingo",
            "San Felipe",
            "Catemu",
            "Llaillay",
            "Panquehue",
            "Putaendo",
            "Santa María",
            "Quilpué",
            "Limache",
            "Olmué",
            "Villa Alemana",
          ],
        },
        {
          region: "Región del Libertador Gral. Bernardo O’Higgins",
          comunas: [
            "Rancagua",
            "Codegua",
            "Coinco",
            "Coltauco",
            "Doñihue",
            "Graneros",
            "Las Cabras",
            "Machalí",
            "Malloa",
            "Mostazal",
            "Olivar",
            "Peumo",
            "Pichidegua",
            "Quinta de Tilcoco",
            "Rengo",
            "Requínoa",
            "San Vicente",
            "Pichilemu",
            "La Estrella",
            "Litueche",
            "Marchihue",
            "Navidad",
            "Paredones",
            "San Fernando",
            "Chépica",
            "Chimbarongo",
            "Lolol",
            "Nancagua",
            "Palmilla",
            "Peralillo",
            "Placilla",
            "Pumanque",
            "Santa Cruz",
          ],
        },
        {
          region: "Región del Maule",
          comunas: [
            "Talca",
            "Constitución",
            "Curepto",
            "Empedrado",
            "Maule",
            "Pelarco",
            "Pencahue",
            "Río Claro",
            "San Clemente",
            "San Rafael",
            "Cauquenes",
            "Chanco",
            "Pelluhue",
            "Curicó",
            "Hualañé",
            "Licantén",
            "Molina",
            "Rauco",
            "Romeral",
            "Sagrada Familia",
            "Teno",
            "Vichuquén",
            "Linares",
            "Colbún",
            "Longaví",
            "Parral",
            "Retiro",
            "San Javier",
            "Villa Alegre",
            "Yerbas Buenas",
          ],
        },
        {
          region: "Región de Ñuble",
          comunas: [
            "Cobquecura",
            "Coelemu",
            "Ninhue",
            "Portezuelo",
            "Quirihue",
            "Ránquil",
            "Treguaco",
            "Bulnes",
            "Chillán Viejo",
            "Chillán",
            "El Carmen",
            "Pemuco",
            "Pinto",
            "Quillón",
            "San Ignacio",
            "Yungay",
            "Coihueco",
            "Ñiquén",
            "San Carlos",
            "San Fabián",
            "San Nicolás",
          ],
        },
        {
          region: "Región del Biobío",
          comunas: [
            "Concepción",
            "Coronel",
            "Chiguayante",
            "Florida",
            "Hualqui",
            "Lota",
            "Penco",
            "San Pedro de la Paz",
            "Santa Juana",
            "Talcahuano",
            "Tomé",
            "Hualpén",
            "Lebu",
            "Arauco",
            "Cañete",
            "Contulmo",
            "Curanilahue",
            "Los Álamos",
            "Tirúa",
            "Los Ángeles",
            "Antuco",
            "Cabrero",
            "Laja",
            "Mulchén",
            "Nacimiento",
            "Negrete",
            "Quilaco",
            "Quilleco",
            "San Rosendo",
            "Santa Bárbara",
            "Tucapel",
            "Yumbel",
            "Alto Biobío",
          ],
        },
        {
          region: "Región de la Araucanía",
          comunas: [
            "Temuco",
            "Carahue",
            "Cunco",
            "Curarrehue",
            "Freire",
            "Galvarino",
            "Gorbea",
            "Lautaro",
            "Loncoche",
            "Melipeuco",
            "Nueva Imperial",
            "Padre las Casas",
            "Perquenco",
            "Pitrufquén",
            "Pucón",
            "Saavedra",
            "Teodoro Schmidt",
            "Toltén",
            "Vilcún",
            "Villarrica",
            "Cholchol",
            "Angol",
            "Collipulli",
            "Curacautín",
            "Ercilla",
            "Lonquimay",
            "Los Sauces",
            "Lumaco",
            "Purén",
            "Renaico",
            "Traiguén",
            "Victoria",
          ],
        },
        {
          region: "Región de Los Ríos",
          comunas: [
            "Valdivia",
            "Corral",
            "Lanco",
            "Los Lagos",
            "Máfil",
            "Mariquina",
            "Paillaco",
            "Panguipulli",
            "La Unión",
            "Futrono",
            "Lago Ranco",
            "Río Bueno",
          ],
        },
        {
          region: "Región de Los Lagos",
          comunas: [
            "Puerto Montt",
            "Calbuco",
            "Cochamó",
            "Fresia",
            "Frutillar",
            "Los Muermos",
            "Llanquihue",
            "Maullín",
            "Puerto Varas",
            "Castro",
            "Ancud",
            "Chonchi",
            "Curaco de Vélez",
            "Dalcahue",
            "Puqueldón",
            "Queilén",
            "Quellón",
            "Quemchi",
            "Quinchao",
            "Osorno",
            "Puerto Octay",
            "Purranque",
            "Puyehue",
            "Río Negro",
            "San Juan de la Costa",
            "San Pablo",
            "Chaitén",
            "Futaleufú",
            "Hualaihué",
            "Palena",
          ],
        },
        {
          region: "Región Aisén del Gral. Carlos Ibáñez del Campo",
          comunas: [
            "Coihaique",
            "Lago Verde",
            "Aisén",
            "Cisnes",
            "Guaitecas",
            "Cochrane",
            "O’Higgins",
            "Tortel",
            "Chile Chico",
            "Río Ibáñez",
          ],
        },
        {
          region: "Región de Magallanes y de la Antártica Chilena",
          comunas: [
            "Punta Arenas",
            "Laguna Blanca",
            "Río Verde",
            "San Gregorio",
            "Cabo de Hornos (Ex Navarino)",
            "Antártica",
            "Porvenir",
            "Primavera",
            "Timaukel",
            "Natales",
            "Torres del Paine",
          ],
        },
        {
          region: "Región Metropolitana de Santiago",
          comunas: [
            "Cerrillos",
            "Cerro Navia",
            "Conchalí",
            "El Bosque",
            "Estación Central",
            "Huechuraba",
            "Independencia",
            "La Cisterna",
            "La Florida",
            "La Granja",
            "La Pintana",
            "La Reina",
            "Las Condes",
            "Lo Barnechea",
            "Lo Espejo",
            "Lo Prado",
            "Macul",
            "Maipú",
            "Ñuñoa",
            "Pedro Aguirre Cerda",
            "Peñalolén",
            "Providencia",
            "Pudahuel",
            "Quilicura",
            "Quinta Normal",
            "Recoleta",
            "Renca",
            "Santiago",
            "San Joaquín",
            "San Miguel",
            "San Ramón",
            "Vitacura",
            "Puente Alto",
            "Pirque",
            "San José de Maipo",
            "Colina",
            "Lampa",
            "Tiltil",
            "San Bernardo",
            "Buin",
            "Calera de Tango",
            "Paine",
            "Melipilla",
            "Alhué",
            "Curacaví",
            "María Pinto",
            "San Pedro",
            "Talagante",
            "El Monte",
            "Isla de Maipo",
            "Padre Hurtado",
            "Peñaflor",
          ],
        },
      ],
    };

    document.querySelectorAll(".js-formulario2").forEach(function (formulario) {
      var regionInput = formulario.querySelector('[name="region"]');
      var comunaInput = formulario.querySelector('[name="comuna"]');

      if (!regionInput || !comunaInput || regionInput.dataset.regionesReady) {
        return;
      }
      regionInput.dataset.regionesReady = "true";

      regionesData.regiones.forEach(function (region) {
        var option = document.createElement("option");
        option.value = region.region;
        option.textContent = region.region;
        regionInput.appendChild(option);
      });

      function updateComunas() {
        var regionSeleccionada = regionInput.value;
        var region = regionesData.regiones.find(function (item) {
          return item.region === regionSeleccionada;
        });

        comunaInput.replaceChildren();
        if (!region) {
          var placeholder = document.createElement("option");
          placeholder.value = "";
          placeholder.disabled = true;
          placeholder.selected = true;
          placeholder.textContent = "Selecciona una región primero";
          comunaInput.appendChild(placeholder);
          return;
        }

        region.comunas.forEach(function (comuna) {
          var option = document.createElement("option");
          option.value = comuna;
          option.textContent = comuna;
          comunaInput.appendChild(option);
        });
      }

      regionInput.addEventListener("change", updateComunas);
      updateComunas();
    });
  });
}

function ppMensajeAltura() {
  const elemento = document.querySelector(".woocommerce-store-notice");
  const body = document.querySelector(".woocommerce-demo-store");
  const navbar = document.querySelector(
    ".woocommerce-demo-store .navbar.sticky-top"
  );

  if (
    !elemento ||
    elemento.hidden ||
    window.getComputedStyle(elemento).display === "none"
  ) {
    if (body) body.style.marginTop = "0px";
    if (navbar) navbar.style.top = "0px";
    return;
  }

  const altura = elemento.offsetHeight;
  if (body) body.style.marginTop = altura + "px";
  if (navbar) navbar.style.top = altura + "px";

  const descartar = elemento.querySelector(
    ".woocommerce-store-notice__dismiss-link"
  );
  if (descartar && descartar.dataset.noticeBound !== "1") {
    descartar.dataset.noticeBound = "1";
    descartar.addEventListener("click", function () {
      window.setTimeout(ppMensajeAltura, 0);
    });
  }
}

function animateValue(obj, start, end, duration) {
  let startTimestamp = null;
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    obj.innerHTML = new Intl.NumberFormat("es-CL").format(
      Math.floor(progress * (end - start) + start)
    );
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
}

function aiepElementoVisible(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function reactorInitAOS() {
  AOS.init({
    duration: 500,
    offset: 50,
    easing: "ease-in-out",
  });
}

export function reactorCompartir() {
  let elementos = document.querySelectorAll(".js-compartir");

  elementos.forEach(function (elemento) {
    elemento.addEventListener("click", (event) => {
      event.preventDefault();
      let url = elemento.href;

      window.open(
        url,
        "fbShareWindow",
        "height=550, width=650, top=" +
          (window.innerHeight / 2 - 275) +
          ", left=" +
          (window.innerWidth / 2 - 225) +
          ", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
      );
    });
  });
}

export function reactorMenuMovil() {
  const menu = document.getElementById("menu-principal");
  const header = document.getElementById("js-header");

  menu.addEventListener("show.bs.collapse", (event) => {
    header.classList.add("navbar--opened");
  });

  menu.addEventListener("hide.bs.collapse", (event) => {
    header.classList.remove("navbar--opened");
  });
}

export function reactorSticky() {
  let pageYOffset = window.pageYOffset,
    sticky = document.getElementById("js-sticky");

  if (sticky) {
    if (pageYOffset > 0) {
      sticky.classList.add("show");
    } else {
      sticky.classList.remove("show");
    }

    window.addEventListener("scroll", (event) => {
      let pageYOffset = window.pageYOffset,
        scroll = window.scrollY;

      if (pageYOffset > 50) {
        sticky.classList.add("show");
      } else {
        sticky.classList.remove("show");
      }
    });
  }
}

export function reactorAnimarCifra() {
  let cifras = document.querySelectorAll(".increase");

  cifras.forEach(function (elemento) {
    let valor = elemento.getAttribute("data-to");

    window.addEventListener("scroll", function (e) {
      let section = elemento.closest(".cifras__container");

      if (
        aiepElementoVisible(section) &&
        !elemento.classList.contains("ready")
      ) {
        animateValue(elemento, 0, valor.split(".").join(""), 5000);
        elemento.classList.add("ready");
      }
    });
  });
}

export function reactorMenu() {
  const header = document.getElementById("js-header");
  if (!header) return;

  // Segunda variante del logo (Apariencia -> Logo claro): el mismo <img> cambia
  // de src junto con el fondo del header. Solo existe si hay dos configuradas.
  const logo = header.querySelector("img[data-logo-sticky]");
  if (logo) {
    // Precarga la variante oscura: si se descarga recien al hacer scroll, el
    // logo parpadea la primera vez.
    new Image().src = logo.dataset.logoSticky;
  }

  const updateHeader = () => {
    const fijo = window.pageYOffset > 50;

    header.classList.toggle("navbar--sticky", fijo);

    if (logo) {
      const src = fijo ? logo.dataset.logoSticky : logo.dataset.logoBase;
      if (src && logo.getAttribute("src") !== src) {
        logo.setAttribute("src", src);
      }
    }
  };

  updateHeader();
  window.addEventListener("scroll", updateHeader, { passive: true });

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".dropdown-menu").forEach(function (element) {
      element.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    });
  });
}

export function reactorCarruselProducto() {
  let carruseles = document.querySelectorAll(".carrusel");

  carruseles.forEach(function (carrusel) {
    let carr = carrusel.querySelector(".carrusel__container"),
      barra = carrusel.querySelector(".carrusel__pag"),
      next = carrusel.querySelector(".carrusel__nav--next"),
      prev = carrusel.querySelector(".carrusel__nav--prev");

    const carruselProducto = new Swiper(carr, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
      pagination: {
        el: barra,
        clickable: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });
  });
}

export function reactorInputNumber() {
  document.querySelector("body").addEventListener("click", function (event) {
    const btn = event.target.closest('.less, .plus, .bi-dash, .bi-plus');
    if (!btn) return;

    const control = btn.closest(".btn-input-number");
    const group = btn.closest(".btn-group-input-number");
    const input = group ? group.querySelector("input.qty") : null;

    if (
      !control ||
      !input ||
      input.disabled ||
      input.readOnly ||
      !["number", "range"].includes(input.type)
    ) return;

    event.preventDefault();

    if (control.classList.contains("less")) input.stepDown();
    if (control.classList.contains("plus")) input.stepUp();

    input.dispatchEvent(new Event("input", { bubbles: true }));
  });
}

export function reactorPlayVideo() {
  let play = document.querySelectorAll(".play");

  play.forEach(function (elemento) {
    let icon = elemento.querySelector(".play__icon"),
      img = elemento.querySelector(".play__img"),
      iframe = elemento.querySelector(".play__iframe");

    if (!iframe) return;
    if (!icon || !img) {
      iframe.classList.remove("d-none");
      return;
    }

    const showVideo = () => {
      icon.classList.remove("show");
      img.classList.remove("show");
      iframe.classList.remove("d-none");
    };

    icon.addEventListener("click", showVideo);
    if (!icon.matches("button, a")) {
      icon.setAttribute("role", "button");
      icon.setAttribute("tabindex", "0");
      icon.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          showVideo();
        }
      });
    }
  });
}

export function suscribeForm() {

  const popupStatusCta2 = document.querySelector(".popup-status-cta2");
  const popupSpinnerCta2 = document.querySelector(".popup-spinner-cta2");
  const subscribeFormCta2 = document.querySelector("#subscribe-form-cta2");
  const subscribeFormsCta = document.querySelectorAll(
    "[data-subscribe-cta-form]"
  );

  function sendSuscribeForm({ form, spinner, status, row }) {
    if (!form || !status) return;
    if (form.dataset.subscribePending === "true") return;

    const value = (name) => {
      const field = form.elements.namedItem(name);
      return field && "value" in field ? field.value : "";
    };

    const submitButton = form.querySelector('[type="submit"]');
    const submitButtonWasDisabled = submitButton?.disabled || false;

    if (spinner) spinner.style.display = "block";
    status.textContent = "";
    status.classList.remove("error");
    form.dataset.subscribePending = "true";
    form.setAttribute("aria-busy", "true");
    if (submitButton) submitButton.disabled = true;

    const data = new URLSearchParams();
    data.append("action", "subscribe_form");
    data.append("nonce", ajax_script.subscribe_nonce);
    data.append("email", value("email"));
    data.append("nombre", value("nombre"));
    data.append("apellido", value("apellido"));

    fetch(ajax_script.ajax_url, {
      method: "POST",
      body: data,
    })
      .then((response) =>
        response
          .json()
          .catch(() => ({}))
          .then((body) => {
            if (!response.ok) {
              console.error("subscribe_form HTTP " + response.status, body);
            }
            return { body, httpCode: response.status, ok: response.ok };
          })
      )
      .then(({ body, httpCode, ok }) => {
        const message =
          typeof body.message === "string"
            ? body.message
            : "No fue posible completar la suscripción.";

        status.textContent = ok
          ? message
          : message + " (HTTP " + httpCode + (body.code ? " / " + body.code : "") + ")";
        if (ok && body.status === "success") {
          status.classList.remove("error");
          form.reset();
          if (row) row.style.display = "none";
        } else {
          status.classList.add("error");
        }
      })
      .catch(() => {
        status.textContent =
          "No fue posible completar la suscripción. Inténtalo nuevamente.";
        status.classList.add("error");
      })
      .finally(() => {
        if (spinner) spinner.style.display = "none";
        delete form.dataset.subscribePending;
        form.removeAttribute("aria-busy");
        if (submitButton) submitButton.disabled = submitButtonWasDisabled;
      });
  }

  subscribeFormsCta.forEach((form) => {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      const scope = form.closest("[data-subscribe-cta]") || form;
      sendSuscribeForm({
        form,
        spinner: scope.querySelector(".popup-spinner-cta"),
        status: scope.querySelector(".popup-status-cta"),
        row: form.querySelector(".row-form-cta"),
      });
    });
  });

  if (subscribeFormCta2 !== null) {
    subscribeFormCta2.addEventListener("submit", function (event) {
      event.preventDefault();
      sendSuscribeForm({
        form: subscribeFormCta2,
        spinner: popupSpinnerCta2,
        status: popupStatusCta2,
        row: subscribeFormCta2.querySelector(".row-form-cta, .row-form"),
      });
    });
  }
}

export function ppueblosFormularioRegistroTienda() {
  const formularios = document.querySelectorAll(".js-formulario-tienda");

  formularios.forEach((formulario) => {
    const validation = new JustValidate(formulario);

    validation
      .addField('[name="nombre"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="apellido"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
      ])
      .addField('[name="rut"]', [
        {
          rule: "required",
          errorMessage: "Rut requerido",
        },
        {
          validator: (value) => ppueblosCheckRut(value, formulario),
          errorMessage: "Rut inválido",
        },
      ])
      .addField('[name="email"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
        {
          rule: "email",
          errorMessage: "Formato inválido",
        },
      ])
      .addField('[name="telefono"]', [
        {
          rule: "required",
          errorMessage: "Campo requerido",
        },
        {
          rule: "number",
          errorMessage: "El valor debe ser numérico",
        },
        {
          rule: "minLength",
          value: 6,
          errorMessage: "Debe contener al menos 6 dígitos",
        },
      ])
      .addField('[name="terminos"]', [
        {
          rule: "required",
          errorMessage: "Debes suscribirte a nuestro newsletter",
        },
      ])
      .onSuccess((event) => {
        event.preventDefault();

        const container =
          formulario.closest(".formulario-contacto__inner") ||
          formulario.parentElement;
        const loading = container?.querySelector(".formulario-loading");
        const spinner = formulario.querySelector(".formulario-spinner");
        const formularioEnviado = container?.querySelector(".formulario-enviado");
        const messageNode = formularioEnviado?.querySelector(
          ".formulario-enviad-text"
        );
        const params = new FormData(event.currentTarget);

        if (loading) loading.style.display = "block";
        if (spinner) spinner.style.display = "inline-block";
        if (formularioEnviado) formularioEnviado.style.display = "none";

        fetch(ajax_script.ajax_url, {
          method: "POST",
          body: params,
          cache: "no-cache",
        })
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            if (loading) loading.style.display = "none";
            if (spinner) spinner.style.display = "none";
            if (messageNode) {
              messageNode.textContent =
                typeof res.mensajes === "string"
                  ? res.mensajes
                  : "Hay errores en el formulario. Por favor, intenta nuevamente.";
            }

            if (formularioEnviado) formularioEnviado.style.display = "block";
          })
          .catch(() => {
            if (loading) loading.style.display = "none";
            if (spinner) spinner.style.display = "none";
            if (messageNode) {
              messageNode.textContent =
                "No fue posible enviar el formulario. Inténtalo nuevamente.";
            }
            if (formularioEnviado) formularioEnviado.style.display = "block";
          });
      });
  });
}

function ppueblosCheckRut(rut, formulario = false) {
  rut = ppueblosFormatearRut(rut, false);

  const ele_rut = formulario.querySelector('[name="rut"]');
  const ele_val = ele_rut.value;

  if (ele_val) {
    ele_rut.value = rut;
  }

  if (rut.length > 0) {
    let texto = rut.split("-");
    if (texto[1] === undefined) {
      return false;
    }
    let dv = texto[1].toUpperCase();
    if (texto[0].length <= 8 && texto[1].length === 1) {
      let aux = "";
      let valor = 0;
      for (let i = 0; i < texto[0].length; i++) {
        if (i === 0) aux = texto[0].substr(i, 1);
        if (texto[0].substr(i, 1) === aux) {
          valor++;
        }
      }
      if (valor === texto[0].length) {
        return false;
      }
      // Calcular Di­gito Verificador
      let suma = 0;
      let multiplo = 2;
      // Para cada digito del Cuerpo
      for (let i = 1; i <= texto[0].length; i++) {
        // Obtener su Producto con el Multiplo Correspondiente
        let index = multiplo * texto[0].charAt(texto[0].length - i);
        // Sumar al Contador General
        suma = suma + index;
        // Consolido Multiplo dentro del rango [2,7]
        if (multiplo < 7) {
          multiplo = multiplo + 1;
        } else {
          multiplo = 2;
        }
      }
      // Calcular Diigito Verificador en base al Modulo 11
      let dvEsperado = 11 - (suma % 11);

      // Casos Especiales (0 y K)
      dv = dv == "K" ? 10 : dv;
      dv = dv == 0 ? 11 : dv;
      // Validar que el Cuerpo coincide con su Di­gito Verificador
      if (dvEsperado != dv) {
        return false;
      } else return true;
    } else {
      return false;
    }
  }
}

function ppueblosFormatearRut(rut, separador = true) {
  const newRut = rut.replace(/\./g, "").replace(/\-/g, "").trim().toLowerCase();
  const lastDigit = newRut.substr(-1, 1);
  const rutDigit = newRut.substr(0, newRut.length - 1);

  if (separador) {
    let format = "";
    let dot = 1;

    for (let i = rutDigit.length; i >= 0; i--) {
      const e = rutDigit.charAt(i - 1);
      format = e.concat(format);
      if (dot % 3 === 0) {
        format = ".".concat(format);
        dot = 1;
        continue;
      }
      dot++;
    }

    return format.charAt(0) === "."
      ? `${format.substring(1, format.length)}-${lastDigit.toUpperCase()}`
      : `${format}-${lastDigit.toUpperCase()}`;
  }

  return `${rutDigit}-${lastDigit.toUpperCase()}`;
}

export function selectorCreadorMobile() {
  const selectors = document.querySelectorAll(".selectorCreadores");
  selectors.forEach((selector) => {
    selector.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];
      const dataBsTarget = selectedOption.getAttribute("data-bs-target");
      const scope = selector.closest("[data-creadores-module]") || document;
      if (!dataBsTarget || !dataBsTarget.startsWith("#")) return;

      const tabs = scope.querySelectorAll(".tab-pane");
      tabs.forEach((tab) => tab.classList.remove("show", "active"));

      const selectedTab = document.getElementById(dataBsTarget.slice(1));
      if (!selectedTab || !scope.contains(selectedTab)) return;
      selectedTab.classList.add("show", "active");
    });
  });
}

export function updateMiniCart() {
  // WooCommerce reemplaza el contador con su API de fragments después de
  // agregar o quitar productos; no hace falta temporizador ni contar el DOM.
}

export function setTabByURL() {
  const tabLinks = document.querySelectorAll(".tab--item-link");
  const fragment = window.location.hash.substring(1);
  if (!fragment) return;

  const activeLink = Array.from(tabLinks).find(
    (link) => link.getAttribute("data-tabtarget") === fragment
  );
  if (!activeLink) return;

  const scope = activeLink.closest("[data-creadores-module]") || document;
  scope.querySelectorAll(".tab--item-link").forEach((link) => {
    const navLink = link.querySelector(".nav-link") || link;
    const isActive = link === activeLink;
    link.classList.toggle("active", isActive);
    navLink.classList.toggle("active", isActive);
    navLink.setAttribute("aria-selected", String(isActive));
  });

  scope.querySelectorAll(".tab-pane").forEach((content) => {
      const dataTab = content.getAttribute("data-tab");
      const isActive = dataTab === fragment;
      content.classList.toggle("active", isActive);
      content.classList.toggle("show", isActive);
  });
}

/**
 * Popup modular: lo muestra pasado el retraso configurado, recuerda el cierre
 * en una cookie y pasa entre modulos cuando hay mas de uno.
 */
export function popupModular() {
  const popup = document.querySelector("[data-pp-popup]");
  if (!popup) return;

  const COOKIE = "ppPopupCerrado";
  const modulos = Array.from(popup.querySelectorAll("[data-pp-popup-modulo]"));
  const puntos = Array.from(popup.querySelectorAll("[data-pp-popup-punto]"));
  const retraso = parseInt(popup.dataset.retraso, 10) || 0;
  const dias = parseInt(popup.dataset.dias, 10) || 0;
  let actual = 0;

  function leerCookie(nombre) {
    return document.cookie
      .split(";")
      .map((trozo) => trozo.trim())
      .find((trozo) => trozo.indexOf(nombre + "=") === 0);
  }

  function guardarCookie(nombre, valor, diasVigencia) {
    const caduca = new Date();
    caduca.setTime(caduca.getTime() + diasVigencia * 24 * 60 * 60 * 1000);
    document.cookie =
      nombre + "=" + valor + ";expires=" + caduca.toUTCString() + ";path=/";
  }

  function mostrarModulo(indice) {
    if (!modulos.length) return;
    actual = (indice + modulos.length) % modulos.length;
    modulos.forEach((modulo, i) => {
      modulo.hidden = i !== actual;
    });
    puntos.forEach((punto, i) => {
      punto.setAttribute("aria-current", i === actual ? "true" : "false");
    });
  }

  function abrir() {
    popup.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function cerrar() {
    popup.hidden = true;
    document.body.style.overflow = "";
    // Sin dias configurados el popup vuelve a salir en la siguiente visita.
    if (dias > 0) guardarCookie(COOKIE, "1", dias);
  }

  popup.querySelectorAll("[data-pp-popup-cerrar]").forEach((boton) => {
    boton.addEventListener("click", cerrar);
  });

  document.addEventListener("keydown", (evento) => {
    if (evento.key === "Escape" && !popup.hidden) cerrar();
  });

  const anterior = popup.querySelector("[data-pp-popup-anterior]");
  const siguiente = popup.querySelector("[data-pp-popup-siguiente]");
  if (anterior) anterior.addEventListener("click", () => mostrarModulo(actual - 1));
  if (siguiente) siguiente.addEventListener("click", () => mostrarModulo(actual + 1));

  puntos.forEach((punto, i) => {
    punto.addEventListener("click", () => mostrarModulo(i));
  });

  popup.querySelectorAll("[data-pp-popup-codigo]").forEach((boton) => {
    boton.addEventListener("click", () => {
      const codigo = boton.dataset.ppPopupCodigo;
      const ayuda = boton.querySelector(".pp-popup__codigo-ayuda");
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(codigo).then(() => {
        if (ayuda) ayuda.textContent = "Copiado";
      });
    });
  });

  if (leerCookie(COOKIE)) return;

  mostrarModulo(0);
  window.setTimeout(abrir, retraso * 1000);
}

/**
 * Crea una flecha de navegacion para el carrusel de la galeria.
 *
 * Es un <div> y no un <button> porque los estilos globales del sitio le dibujan
 * un borde a todo <button>; se le devuelve el rol y el manejo de teclado a mano.
 *
 * @param {string} clase   Clase de Swiper: "swiper-button-prev" o "swiper-button-next".
 * @param {string} etiqueta Texto accesible del control.
 * @returns {HTMLDivElement} La flecha lista para insertar.
 */
function crearFlechaCarrusel(clase, etiqueta) {
  const flecha = document.createElement("div");

  flecha.className = clase;
  flecha.setAttribute("role", "button");
  flecha.setAttribute("tabindex", "0");
  flecha.setAttribute("aria-label", etiqueta);
  flecha.addEventListener("keydown", function (evento) {
    if (evento.key !== "Enter" && evento.key !== " ") {
      return;
    }

    evento.preventDefault();
    flecha.click();
  });

  return flecha;
}

/**
 * Convierte la galeria del widget "image-gallery" de Elementor en un carrusel.
 *
 * Reordena el markup que ya imprime WordPress en la estructura que espera
 * Swiper y le agrega flechas y bullets. Si el JavaScript no corre, la galeria
 * se sigue viendo como la grilla original.
 *
 * @returns {void}
 */
export function reactorGaleriaCarrusel() {
  const galerias = document.querySelectorAll(".elementor-image-gallery");

  galerias.forEach(function (galeria) {
    const wrapper = galeria.querySelector(".gallery");

    if (!wrapper || wrapper.classList.contains("swiper-wrapper")) {
      return;
    }

    const slides = wrapper.querySelectorAll(".gallery-item");

    if (!slides.length) {
      return;
    }

    const carrusel = document.createElement("div");
    carrusel.className = "pp-galeria-carrusel";

    const contenedor = document.createElement("div");
    contenedor.className = "pp-galeria-carrusel__container swiper";

    wrapper.parentNode.insertBefore(carrusel, wrapper);
    contenedor.appendChild(wrapper);
    carrusel.appendChild(contenedor);

    wrapper.classList.add("swiper-wrapper");
    slides.forEach(function (slide) {
      slide.classList.add("swiper-slide");
    });

    const prev = crearFlechaCarrusel("swiper-button-prev", "Imagen anterior");
    const next = crearFlechaCarrusel("swiper-button-next", "Imagen siguiente");

    const navegacion = document.createElement("div");
    navegacion.className = "swiper-navigation pp-galeria-carrusel__nav";
    navegacion.append(prev, next);

    const paginacion = document.createElement("div");
    paginacion.className = "swiper-pagination pp-galeria-carrusel__pag";

    carrusel.append(navegacion, paginacion);

    new Swiper(contenedor, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.2,
      spaceBetween: 16,
      rewind: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
      pagination: {
        el: paginacion,
        clickable: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });
  });
}
